export default __webpack_public_path__ + "static/media/comments.5f48d7e0.svg";